import { Auth } from 'aws-amplify';

import env from '../config/env';

export const getDefaultHeaders = async currentSession => {
    return {
        Authorization: await getAuthToken(currentSession),
        'X-Api-Key': env.API_KEY,
    };
};

async function getAuthToken(currentSession) {
    currentSession = currentSession ? currentSession : await Auth.currentSession();
    return currentSession.idToken.jwtToken;
}
